export default Object.freeze({
  DR: 1,
  DO: 2,
  AC: 3
});